export const getUserToken = 'getUserToken';
export const getUserLogged = 'getUserLogged';
export const logout = 'logout';
